import Settings from "src/components/Settings/Settings";

const SettingsPage = () => {
  return <Settings />;
};

export default SettingsPage;
